type Props = {
  children: React.ReactNode;
  onClick(e: React.MouseEvent<SVGGElement>): void;
  onContextMenu?(e: React.MouseEvent<SVGGElement>): void;
};

/**
 * マウスホバー時のスタイリングなどの機会を子コンポーネントに提供するためのラッパークラス。
 *
 * 子コンポーネントのclassNameに group-hover/link:fill-brand などを指定することで、
 * マウスホバーしたときに色を変えるなどのスタイリングができるようにする。
 *
 * https://tailwindcss.com/docs/hover-focus-and-other-states#group-hover
 */

export const LinkWrapperView: React.FC<Props> = ({ children, onClick, onContextMenu }: Props) => {
  return (
    <g className="group/link" cursor={'pointer'} onClick={onClick} onContextMenu={onContextMenu}>
      {children}
    </g>
  );
};
